import { ErrorNotice } from '@bcecloud/portal-ui';
import { Button } from '../ui/button';
import { joinWithAnd } from '../lib/library-pages';

/** A library insert that left some of the proposal's own data in place. */
export interface LibraryInsertReport {
  /** The library item that was added. */
  readonly name: string;
  /** The data keys the proposal already had, so the item's values were not copied in. */
  readonly skippedKeys: readonly string[];
}

/** The notice's sentence: which item, and which of this proposal's own lists it kept. */
export function libraryInsertMessage(report: LibraryInsertReport): string {
  const keys = joinWithAnd(report.skippedKeys.map((key) => `"${key}"`));
  return `"${report.name}" was added. This proposal already had its own ${keys}, so the new pages show this proposal's version. Check they read the way you want.`;
}

export interface LibraryInsertNoticeProps {
  readonly report: LibraryInsertReport;
  readonly onDismiss: () => void;
}

/** Shown under the top bar after a library insert that kept some of this proposal's data. */
export function LibraryInsertNotice({ report, onDismiss }: LibraryInsertNoticeProps): React.ReactElement {
  return (
    <div className="border-b bg-card px-3 pt-3">
      <ErrorNotice
        inline
        tone="warning"
        message={libraryInsertMessage(report)}
        action={
          <Button variant="secondary" size="sm" onClick={onDismiss}>
            Dismiss
          </Button>
        }
      />
    </div>
  );
}
